import { Dispatch } from 'react';

import { TabType } from '../types';

import { EditPageProps } from './EditTabs';
import Accounts from './Tabs/Accounts/Accounts';
import DataPermissions from './Tabs/DataPermissions/DataPermissions';
import General from './Tabs/General/General';
import Permissions from './Tabs/Permissions/Permissions';

export interface SwitcherProps {
  currentTab: TabType;
  rows: EditPageProps['rows'];
  setIsNavigationDisabled: Dispatch<any>;
  toggleInnerLayout: () => void;
  setCurrentViewData: Dispatch<any>;
  setIsDirty: Dispatch<any>;
  currentViewData: any;
}

export type TabProps = Pick<
  SwitcherProps,
  | 'rows'
  | 'currentViewData'
  | 'setCurrentViewData'
  | 'toggleInnerLayout'
  | 'setIsNavigationDisabled'
  | 'setIsDirty'
>;

const TabRenderer = ({ currentTab, ...props }: SwitcherProps) => {
  switch (currentTab) {
    case TabType.GENERAL:
      return <General {...props} />;
    case TabType.LOGICAL_PERMISSIONS:
      return <Permissions {...props} />;
    case TabType.DATA_PERMISSIONS:
      return <DataPermissions {...props} />;
    case TabType.USERS:
      return <Accounts {...props} />;
    default:
      return <div />;
  }
};

export default TabRenderer;
